import { render } from "./SetUser.vue?vue&type=template&id=b32f9208"
import script from "./SetUser.vue?vue&type=script&lang=js"
export * from "./SetUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__